import React, { useEffect, useState,useRef } from 'react';
import ContantLoader from 'views/ContantLoader';
import './SelectTemplateComponent/styles.css'
import {  getTemplates } from 'api/TemaplateApi';
import {postCampaignData} from 'api/CampaignApi'
import { setCampaignWidget,setisNewCampaignTempateId , setCampaignHtml,setCampaignIsAdvisor } from "ReduxStore/Slices/campaignSlice";
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery'
import 'toolcool-color-picker';


export default function SelectTemplateTab({
  data,
  cancelFn,
  id,
  tab,
  templateData,
  loading,
  urlToCreateTemplate,
  setTemplateOnTheURL,
  offSet,
  PreviousDataShowing,
  matchNextButton,
  NextDataShowing,
  templatePageCount,
  templateCount,
  advisor
}) {
  const userSetter = useSelector((state) => state.userSetter);
  const campaignSetter = useSelector((state) => state.campaignSetter);
  const templateSetter = useSelector((state) => state.templateSetter);
  const iFrameRef = useRef(null);
  const campaignData = useSelector((state) => state.campaignSetter);
  const dispatch = useDispatch();

  const [dumy ,setDumy] = useState(``)
  const [tempId ,setTempId] = useState('')
  const [tempName ,setTempName] = useState('')
  const [loaded , setLoaded] = useState(false)


  const [ltState , setLtState] = useState('footer')
  const [position, setPosition] = useState('right')
  const [dispActive, setDispActive] = useState("true")

  const acTheme = useRef(null);
  const acBack = useRef(null);
  const acFc = useRef(null);
  const acOc  = useRef(null);


  useEffect(() => {


    acTheme.current.addEventListener('change', (e)=>{changeProperty(e.detail.hex,'adv-btn-color'); setTempName(e.detail.hex) });
    acBack.current.addEventListener('change', (e)=>{changeProperty(e.detail.hex,'adv-back-color') });
    acFc.current.addEventListener('change', (e)=>{changeProperty(e.detail.hex,'adv-qs-color') });
    acOc.current.addEventListener('change', (e)=>{changeProperty(e.detail.hex,'adv-opt-color') });


}, []);


useEffect(()=>{
//   console.log("klkop",templateData)

  // let html = campaignData && campaignData['grapesjs-react-editorhtml']? campaignData['grapesjs-react-editorhtml'] :""
  // if( campaignData && campaignData['grapesjs-react-editorhtml']  ){
  //   if(html.includes('adv-btn')){

  //   setDumy(html)
  //   var doc = iFrameRef.current.contentWindow.document;
  //   doc.open();
  //   doc.write(html);
  //   doc.close();
  // }
    
  
// }

let html = data &&data['grapesjs-react-editorhtml']? data['grapesjs-react-editorhtml'] :""
let demoRegex =  /<\!--ac-demo-->.*<\!--ac-demo\$-->/g

html = html.replaceAll(demoRegex,`<!--ac-demo--> <meta name="ondemo" content="true" >   <!--ac-demo$-->`)

let regex = /\/\*\$adv-title\*\/.*\/\*adv-title\$\*\//g

html = html.replaceAll(regex,`/*$adv-title*/ '${campaignData?.campaignName}'   /*adv-title$*/`)

function ddd(x){
  if(x=='#fff')
    return '#ffffff'
  if(x=='#000')
    return'#000000'
  return x
  }

let allText = html

let v1 =  retrieveProp(allText,'adv-back-color')
let v2 =  retrieveProp(allText,'adv-btn-color')
let v3 =  retrieveProp(allText,'adv-qs-color')
let v4 =  retrieveProp(allText,'adv-qs-fam')
let v5 =  retrieveProp(allText,'adv-opt-color')
v1=ddd(v1)
v2=ddd(v2)
v3=ddd(v3)
v4=ddd(v4)
v5=ddd(v5)

$("#ac-theme").val(v2)
$("#ac-back").val(v1)
$("#ac-fc").val(v3)
$("#ac-oc").val(v5)

if (acTheme.current)
  acTheme.current.color= v2;
if (acBack.current)
  acBack.current.color= v1;
if (acFc.current)
  acFc.current.color= v3;
if (acOc.current)
  acOc.current.color= v5;


console.log("vallllllllllllllllll",v1,v2,v3,v4,v5 )


if(data && data.widgetType){
  console.log("Www",data.widgetType)
  // $("#ac-layout").val(data.widgetType)

  setLtState(data.widgetType)
}

setDumy(html)
    var doc = iFrameRef.current.contentWindow.document;
    doc.open();
    doc.write(html);
    doc.close();

    setTempId(data?.id)


},[campaignData])

  const saveCamp = ()=>{
    let layout =  ltState
    let tm = $("#ac-theme").val()


    let themeColor = tempName;
    console.log("themeColor",themeColor)



    let htmlData = `${dumy}`

    if(layout == 'footer' || layout == 'sidebar'){
      let regex =  /<\!--ac-header-->.*<\!--ac-header\$-->/g

      htmlData = htmlData.replaceAll(regex,
        `<!--ac-header--> 
          <meta name="viewHeader" content="false" > 
          <link href="https://kw-dev-cdn.s3.amazonaws.com/v1.0/leadcalculators/css/${layout}.css" rel="stylesheet"> 
        <!--ac-header$-->`)
    }
    else {
      let regex =  /<\!--ac-header-->.*<\!--ac-header\$-->/g

      htmlData = htmlData.replaceAll(regex,
        `<!--ac-header--> 
          <meta name="viewHeader" content="true" >   
          <link href="https://kw-dev-cdn.s3.amazonaws.com/v1.0/leadcalculators/css/${layout}.css" rel="stylesheet"> 
        <!--ac-header$-->`)
    }

    let demoRegex =  /<\!--ac-demo-->.*<\!--ac-demo\$-->/g

    htmlData = htmlData.replaceAll(demoRegex,`<!--ac-demo--> <meta name="ondemo" content="false" >   <!--ac-demo$-->`)
  
    let leadTheme = {
      'adv-back-color': retrieveProp(htmlData,'adv-back-color'),
      'adv-btn-color': retrieveProp(htmlData,'adv-btn-color'),
'adv-qs-color':retrieveProp(htmlData,'adv-qs-color'),
'adv-qs-fam': retrieveProp(htmlData,'adv-qs-fam'),
'adv-opt-color':retrieveProp(htmlData,'adv-opt-color')
    }

    postCampaignData({'grapesjs-react-editorhtml' : htmlData , leadTheme:leadTheme, isAdvisorConnect : true , widgetType:layout, themeColor: tempName ,templateId:tempId, position: position, dispActive: dispActive } , campaignData.campaignId).then((d)=>{
      dispatch(setisNewCampaignTempateId(false));
      dispatch(setCampaignHtml(dumy))
      setTemplateOnTheURL()
      dispatch(setCampaignIsAdvisor(true))
      dispatch(setCampaignWidget(layout))


    }).catch((e)=>{ console.log(e)})




  }
  useEffect(()=>{


    // function readTextFile(file)
    // {
    //     var rawFile = new XMLHttpRequest();
    //     rawFile.open("GET", file, false);
    //     rawFile.onreadystatechange = function ()
    //     {
    //         if(rawFile.readyState === 4)
    //         {
    //             if(rawFile.status === 200 || rawFile.status == 0)
    //             {
    //                 // var allText = rawFile.responseText;
    //                 // console.log(allText)
    //                 // setDumy(allText)
    //                 //     var doc = iFrameRef.current.contentWindow.document;
    //                 //     doc.open();
    //                 //     doc.write(allText);
    //                 //     doc.close();
    //             }
    //         }
    //     }
    //     rawFile.send(null);
    // }
    // readTextFile("http://127.0.0.1:5500/play.html");
    // loadTemp()





  },[])

  function loadTemp (){
    function ddd(x){
      if(x=='#fff')
        return '#ffffff'
      if(x=='#000')
        return'#000000'
      return x
      }
    getTemplates("publishedContent", "advisorConnect", 10, 0)
    .then((data) => {
      setTempId(data[0].id)
          
          let allText = campaignData && campaignData.isAdvisor && campaignData.html? campaignData.html : data[0]['grapesjs-react-editorhtml']
          let regex = /\/\*\$adv-title\*\/.*\/\*adv-title\$\*\//g
          
          allText = allText.replaceAll(regex,`/*$adv-title*/ '${campaignData.campaignName}'   /*adv-title$*/`)


          let demoRegex =  /<\!--ac-demo-->.*<\!--ac-demo\$-->/g

          allText = allText.replaceAll(demoRegex,`<!--ac-demo--> <meta name="ondemo" content="true" >   <!--ac-demo$-->`)
          
          let v1 =  retrieveProp(allText,'adv-back-color')
          let v2 =  retrieveProp(allText,'adv-btn-color')
          let v3 =  retrieveProp(allText,'adv-qs-color')
          let v4 =  retrieveProp(allText,'adv-qs-fam')
          let v5 =  retrieveProp(allText,'adv-opt-color')
          v1=ddd(v1)
          v2=ddd(v2)
          v3=ddd(v3)
          v4=ddd(v4)
          v5=ddd(v5)

          $("#ac-theme").val(v2)
          $("#ac-back").val(v1)
          $("#ac-fc").val(v3)
          $("#ac-oc").val(v5)

          acTheme.current.color= v2;
          acBack.current.color= v1;
          acFc.current.color= v3;
          acOc.current.color= v5;

          //font fam
          $("#ac-fo").val(v4)

          if(campaignData && campaignData.widgetType){
            console.log("Www",campaignData.widgetType)
            // $("#ac-layout").val(campaignData.widgetType)
            setLtState(campaignData.widgetType)

          }

   
          
           regex =  /<\!--ac-header-->.*<\!--ac-header\$-->/g
      
          allText = allText.replaceAll(regex,`<!--ac-header--> <meta name="viewHeader" content="true" >   <!--ac-header$-->`)
          
      

          console.log("koppppp",v1,v2,v3,v4,v5 , campaignData)



                    if(allText.includes('adv-btn')){
                    // setTimeout(() => {
                      var doc = iFrameRef.current.contentDocument;
                      doc.open();
                      doc.write(allText);
                      doc.close();
                      setDumy(allText)

                    }

                    // }, 2000);

         
    })
    .catch((e) => { })
  }
  function changeButtonColor(color){
    let text = dumy;


    setDumy( text.replace(/\/\*\$adv-btn\*\/.*\/\*adv-btn\$\*\//,`/*$adv-btn*/  ${color}   /*adv-btn$*/`))


  }

  function retrieveProp (text , prop){
    let regex;
    if(prop == 'adv-back-color'){
      regex = /\/\*\$adv-back-color\*\/.*\/\*adv-back-color\$\*\//g
    }
    if(prop == 'adv-btn-color'){
      regex = /\/\*\$adv-btn-color\*\/.*\/\*adv-btn-color\$\*\//g
    }
    if(prop == 'adv-qs-color'){
      regex = /\/\*\$adv-qs-color\*\/.*\/\*adv-qs-color\$\*\//g
    }
    if(prop == 'adv-qs-fam'){
      regex = /\/\*\$adv-qs-fam\*\/.*\/\*adv-qs-fam\$\*\//g
    }
    if(prop == 'adv-opt-color'){
      regex = /\/\*\$adv-opt-color\*\/.*\/\*adv-opt-color\$\*\//g
    }

    let str = text.match(regex)[0]

    return str.substring( str.indexOf("*/") + 2,  str.lastIndexOf("/*")).trim() 
  }
  function changeProperty(value, prop){
    var doc = iFrameRef.current.contentWindow.document;
    let text =  `${doc.documentElement.innerHTML}`;
    
    let regex;
    if(prop == 'adv-back-color'){
      regex = /\/\*\$adv-back-color\*\/.*\/\*adv-back-color\$\*\//g
    }
    if(prop == 'adv-btn-color'){
      regex = /\/\*\$adv-btn-color\*\/.*\/\*adv-btn-color\$\*\//g
    }
    if(prop == 'adv-qs-color'){
      regex = /\/\*\$adv-qs-color\*\/.*\/\*adv-qs-color\$\*\//g
    }
    if(prop == 'adv-qs-fam'){
      regex = /\/\*\$adv-qs-fam\*\/.*\/\*adv-qs-fam\$\*\//g
    }
    if(prop == 'adv-opt-color'){
      regex = /\/\*\$adv-opt-color\*\/.*\/\*adv-opt-color\$\*\//g
    }


    text = '<!DOCTYPE html>' +text.replaceAll(regex,`/*$${prop}*/  ${value}   /*${prop}$*/`)
    if(text.includes('adv-btn')){

    console.log(text)
    doc.open();
    doc.write(text);
    doc.close();
    setDumy(text)
    }
  }

  const showTemplateEditCard = () => {
    if (userSetter.userFlow == 'createCampaign') {
      if (campaignSetter.currentABTestCampaign == 'A') {
        return campaignSetter.campignTemplateId !== null ? true : false;
      } else if (campaignSetter.currentABTestCampaign == 'B') {
        return campaignSetter.campaingABTestData.campaignABTestTemplateId !== null ? true : false;
      }
    } else if (userSetter.userFlow == 'createTemplate') {
      return templateSetter.templateId !== null ? true : false;
    }
    return;
  };

  return (
    <form className='template_block'
    
    onSubmit={(e)=>{
      e.preventDefault();
      saveCamp()
    }}
    >
            <div className="page_heading" style={{paddingTop:"17px"}}>
        <h2>{data.category =='smartConnect'?  "Customize your SmartWidget": "Customize AdvisorConnect Widget"}</h2>

        <p className="sm d-flex align-items-center">
        Brand the widget to match your website.
        <input type="submit" style={{marginLeft:'auto'}} className="lg_btn primary mb-2" value="Save" />{" "}
        <input type="button" style={{marginLeft:'12px'}} className="lg_btn tertiary mb-2" value="Cancel"  onClick={cancelFn} />{" "}

        </p>

      </div>
  <div
   style={{ backgroundColor:"#eee" , width:"100%" , height:"1px"}}
  ></div>

{/* <div
   style={{  backgroundColor:"#1d2036" , width:"100%" , height:"5px"}}
  ></div> */}


      {!loading ? (
        <div style={{display :"flex"}}>
                    <div style={{display:"flex" , justifyContent:"center" , marginTop:"0px", width:"100%"}}>
            <iframe  onLoad={
              (e)=>{

              // if(!loaded){
              
              //   setLoaded(true);

              // }else{
              //   console.log("!loaded")
              // }

            }} ref={iFrameRef} style={{overflow:"hidden" , width:"60%", height:"90vh" , border:"2px #eeee solid", marginTop:"20px", borderRadius:"3%"}}>

            </iframe>
          </div>
               <div className='adv-panel'>
               <div className='adv-op' id='h1' name='ff1'> Button Color
                {/* <input id='ac-theme' name='c1' defaultValue={'#2C40CE'} onChange={(e)=>{changeProperty(e.target.value,'adv-btn-color')}} className='adv-color' type="color"></input>  */}
                <toolcool-color-picker  ref={acTheme}  color="#2C40CE"button-width="100%" popup-position="right" />

                </div>
                <div className='adv-op' id='h2'  name='ff2'> Background Color 
                {/* <input id='ac-back'  name='c2' defaultValue={'#ffffff'} onChange={(e)=>{changeProperty(e.target.value,'adv-back-color')}} className='adv-color' type="color"></input>  */}
                <toolcool-color-picker ref={acBack}  color="#2C40CE"button-width="100%" popup-position="right" />

                </div>
                <div className='adv-op' id='h3'  name='ff3'>  Question Font Color
                 {/* <input id='ac-fc' name='c3' defaultValue={'#000000'} onChange={(e)=>{changeProperty(e.target.value,'adv-qs-color')}} className='adv-color' type="color"></input> */}
                 <toolcool-color-picker ref={acFc}  color="#2C40CE"button-width="100%" popup-position="right" />

                 </div>
                <div className='adv-op' id='h3'  name='ff3'> Option Color
                 {/* <input id='ac-oc' name='c4' defaultValue={'#666666'} onChange={(e)=>{changeProperty(e.target.value,'adv-opt-color')}} className='adv-color' type="color"></input>  */}
                 <toolcool-color-picker ref={acOc}  color="#2C40CE"button-width="100%" popup-position="right" />

                </div>
                
                
                
                <div className='adv-op-sel'> <span>Font Family </span>
                <select id='ac-fo'  onChange={(e)=>{changeProperty(e.target.value,'adv-qs-fam')}} className='adv-sel'>
                      <option value="'Liberation Serif'">Liberation Serif</option>

                      <option value="'Gordita Regular', sans-serif">Gordita, sans-serif</option>
                      <option value='"Gill Sans", sans-serif'>Gill Sans, sans-serif</option>
                      <option value=' sans-serif'> sans-serif</option>
                      <option value='serif'>serif</option>
                      <option value='cursive'>cursive</option>
                      <option value='system-ui'>system-ui</option>
                      <option value="'DM sans'">DM sans</option>
                      <option value="'Monospace'">Monospace</option>
                      
                      </select> 
                    </div>

                    <div className='adv-op-sel'  > <span> Layout </span> <select id = 'ac-layout'  value={ltState}  onChange={(e)=>{setLtState(e.target.value)}}   className='adv-sel'>
                    <option value="footer">Floating Widget</option>
                      <option value="default">Embed Div</option>
                      <option value="sidebar">Sidebar</option>

                      </select> 
                    </div>
                    {
                      ltState === 'footer' ?
                    <div className='adv-op-sel'  > <span> Position </span> <select id = 'ac-position' value={position}  onChange={(e)=>{setPosition(e.target.value)}} className='adv-sel'>
                    <option value="left">Left</option>
                      <option value="right">Right</option>

                      </select> 
                    </div>  :
                      ''
                    }

                    {ltState === "footer" || ltState === "sidebar" ? (
                      <div className="adv-op-sel"> <span> Display Active </span> <select id="ac-disp-active" value={dispActive} onChange={(e) => { setDispActive(e.target.value); }} className="adv-sel" >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </div>
                    ) : (
                      ""
                    )}
               </div>

          

              {/* <div className='adv-main'>
                <div className='adv-op' id='h1' name='ff1'> Button Color <input id='ac-theme' name='c1' defaultValue={'#2C40CE'} onChange={(e)=>{changeProperty(e.target.value,'adv-btn-color')}} className='adv-color' type="color"></input> </div>
                <div className='adv-op' id='h2'  name='ff2'> Background Color <input name='c2' defaultValue={'#ffffff'} onChange={(e)=>{changeProperty(e.target.value,'adv-back-color')}} className='adv-color' type="color"></input> </div>
                <div className='adv-op' id='h3'  name='ff3'>  Question Font Color <input name='c3' defaultValue={'#000000'} onChange={(e)=>{changeProperty(e.target.value,'adv-qs-color')}} className='adv-color' type="color"></input> </div>
                <div className='adv-op' id='h3'  name='ff3'> Option Color <input name='c4' defaultValue={'#666666'} onChange={(e)=>{changeProperty(e.target.value,'adv-opt-color')}} className='adv-color' type="color"></input> </div>

                  <input type="submit" style={{marginLeft:'auto'}} className="lg_btn primary mb-2" value="Save" />{" "}


              </div> */}
                  {/* <div className='adv-main'>

                  <div className='adv-op'> Font Family<select  onChange={(e)=>{changeProperty(e.target.value,'adv-qs-fam')}} className='adv-sel'>
                      <option value="'Liberation Serif'">Liberation Serif</option>

                      <option value='Georgia, serif'>Georgia, serif</option>
                      <option value='"Gill Sans", sans-serif'>Gill Sans, sans-serif</option>
                      <option value=' sans-serif'> sans-serif</option>
                      <option value='serif'>serif</option>
                      <option value='cursive'>cursive</option>
                      <option value='system-ui'>system-ui</option>
                      <option value="'DM sans'">DM sans</option>
                      </select> 
                    </div>

                    <div className='adv-op'  > Layout <select id = 'ac-layout' value={campaignData&& campaignData.widgetType}  className='adv-sel'>
                      <option value="default">Embed Div</option>
                      <option value="footer">Floating Widget</option>

                      </select> 
                    </div>
                  </div> */}



        </div>

      ) : (
        <ContantLoader />
      )}
    </form>
  );
}
